import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const financialReportsRoute: IExtendedRouteObject[] = [
  {
    route: {
      path: path.financialReports.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialReports/financialReports"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialReports",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["super-admin", "admin", "local-admin"],
  },
];
